import { render } from "./_VisualizarSql.vue?vue&type=template&id=a4cbedac&scoped=true"
import script from "./_VisualizarSql.vue?vue&type=script&lang=ts"
export * from "./_VisualizarSql.vue?vue&type=script&lang=ts"

import "./_VisualizarSql.vue?vue&type=style&index=0&id=a4cbedac&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a4cbedac"

export default script